import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as Logos from "@universityofmaryland/web-icons-library/logos";
import { createCompositeFooterCampaign } from "../campaign.js";
import { createCompositeFooterCallToAction } from "../call-to-action.js";
import { BREAKPOINTS } from "../../../globals.js";
const { LARGE } = BREAKPOINTS;
const createLogoLinkElement = (props) => {
  const { slotLogo, isThemeLight } = props;
  const createDefaultLogoLink = () => {
    const logoLink2 = document.createElement("a");
    logoLink2.setAttribute("href", "https://umd.edu");
    logoLink2.setAttribute("target", "_blank");
    logoLink2.setAttribute("rel", "noopener noreferrer");
    logoLink2.setAttribute(
      "aria-label",
      "Link to the University of Maryland homepage"
    );
    logoLink2.innerHTML = !isThemeLight ? `${Logos.umd.dark}` : `${Logos.umd.light}`;
    return logoLink2;
  };
  const logoLink = slotLogo ?? createDefaultLogoLink();
  return new ElementBuilder(logoLink).withClassName("umd-footer-logo-container_link").withStyles({
    element: {
      maxWidth: "310px",
      alignSelf: "flex-start",
      backgroundSize: 0,
      display: "block !important",
      [`& svg`]: {
        width: "100%"
      }
    }
  }).build();
};
const createContainer = (logoLinkElement, campaignElement, callToActionElement) => {
  return new ElementBuilder().withClassName("umd-footer-logo-container").withChildren(logoLinkElement, campaignElement, callToActionElement).withStyles({
    element: {
      marginTop: "5px",
      [`@container (max-width: ${LARGE - 1}px)`]: {
        [`& .umd-footer-call-to-action-container`]: {
          marginTop: token.spacing.md
        }
      },
      [`@container (min-width: ${LARGE}px)`]: {
        [`& > .campaign-column-wrapper`]: {
          display: "none"
        },
        ["& > .umd-footer-call-to-action-container"]: {
          display: "none"
        }
      }
    }
  }).build();
};
const CreateLogoElement = (props) => {
  const logoLinkElement = createLogoLinkElement(props);
  const campaignElement = createCompositeFooterCampaign(props);
  const callToActionElement = createCompositeFooterCallToAction(props);
  return createContainer(logoLinkElement, campaignElement, callToActionElement);
};
const createCompositeFooterLogo = CreateLogoElement;
export {
  createCompositeFooterLogo
};
//# sourceMappingURL=logo.js.map
